// Shared section colors for waveform regions and lyric borders
export const SECTION_COLORS = [
  "rgba(196, 164, 78, 0.35)",   // gold
  "rgba(122, 184, 146, 0.35)",  // green
  "rgba(232, 93, 74, 0.35)",    // ember
  "rgba(139, 92, 246, 0.35)",   // purple
  "rgba(59, 130, 246, 0.35)",   // blue
  "rgba(236, 72, 153, 0.35)",   // pink
  "rgba(245, 158, 11, 0.35)",   // amber
  "rgba(16, 185, 129, 0.35)",   // teal
];

export const SECTION_BORDER_COLORS = [
  "rgba(196, 164, 78, 0.85)",
  "rgba(122, 184, 146, 0.85)",
  "rgba(232, 93, 74, 0.85)",
  "rgba(139, 92, 246, 0.85)",
  "rgba(59, 130, 246, 0.85)",
  "rgba(236, 72, 153, 0.85)",
  "rgba(245, 158, 11, 0.85)",
  "rgba(16, 185, 129, 0.85)",
];
